import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { Edit3, Eye, Trash2, File } from 'react-feather';
import IconButton from '@mui/material/IconButton';
import '../../styles/table.css'; // Importing the external CSS
import Grid from '@mui/material/Grid2';
import { PlusCircle } from 'react-feather';
import { Chip, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Toastmessage from '../../components/Toast';
import { Link } from 'react-router-dom';
import { authApi } from '../../api/api';
import { useSelector } from 'react-redux';
import { logout } from '../../features/auth/AuthSlice';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';



export default function Matters({ apiResponse }) {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]); // Store filtered data
  const [searchText, setSearchText] = useState('');
  const [open, setOpen] = useState(false);
  const [deleteEsate, setDeleteEsate] = useState('')


  const token = useSelector((state) => state.auth.token); // Get the token from Redux
  const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

  const dispatch = useDispatch()
  const navigate = useNavigate();

  
const menuItems = ['All Matters', 'My Matters', 'Open Matters', 'Closed Matters'];
const [activeMenu, setActiveMenu] = useState(menuItems[0]);

  useEffect(() => {
    fetchClients();
  }, [token, userID]); // Run effect when token or userID changes


  // Define fetchDesignation separately to reuse it
  const fetchClients = async () => {
    const input_token =  "13" + userID + 'LIST_CASES'
    const apiUrl = 'list_of_cases'

    const dataInput = {
      login_user_id: userID,
      "firm_id":"13"
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {
        setRows(data.result);
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };

  const handleClickEdit = (id) => {
    navigate('/mattersdetails', { state: { estateID: id } });
  };
  const handleClickView = (id) => {
    navigate('/mattersdetails', { state: { estateID: id } });
  };

  const columns = [
    {
      field: "case_name",
      headerName: "Matter Name",
      flex: 1.4,
      renderCell: (params) => (
        <Link href="#" underline="hover">
          {params.value}
        </Link>
      ),
    },
    // {
    //   field: "matter_type",
    //   headerName: "Matter Type",
    //   flex: 1,
    //   renderCell: (params) => (
    //     <p>
    //       {params?.row?.clients?.name}
    //     </p>
    //   ),
    // },
    { field: "description", headerName: "Description", flex: 1, 

      renderCell: (params) => (
        <p>
         {params?.row?.description}
        </p>
      ),
    },
    {
        field: "updated_at",
        headerName: "Due Date",
        flex: 1,
        renderCell: (params) => {
            const date = params.value ? new Date(params.value) : null;
            return (
            <Typography fontSize={13}>
                {date ? date.toLocaleDateString("en-GB") : "--"}
            </Typography>
            );
        },
    },
,
    {
      field: "closed_date",
      headerName: "Closed Date",
      flex: 1,
      renderCell: (params) => {
            const date = params.value ? new Date(params.value) : null;
            return (
            <Typography fontSize={13}>
                {date ? date.toLocaleDateString("en-GB") : "--"}
            </Typography>
            );
        },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.8,
      renderCell: (params) => (
        <>
          {apiResponse?.data?.actions?.view && (
            <IconButton
              onClick={() => handleClickView(`${params.row.id}`)}
              sx={{
                backgroundColor: 'var(--action-icon-bg)',
                color: 'var(--action-icon-color)',
                borderRadius: '50%',
                padding: '8px', // Reduce padding size
                marginRight: '8px',
              }}
              size="small" // Decrease the button size
            >
              <Eye size={16} /> {/* Smaller Feather icon size */}
            </IconButton>
          )}
          {apiResponse?.data?.actions?.edit && (
            <IconButton
              onClick={() => handleClickEdit(`${params.row.id}`)}
              sx={{
                backgroundColor: 'var(--action-icon-bg)',
                color: 'var(--action-icon-color)',
                borderRadius: '50%',
                padding: '8px', // Reduce padding size
                marginRight: '8px',
              }}
              size="small" // Decrease the button size
            >
              <Edit3 size={16} /> {/* Smaller Feather icon size */}
            </IconButton>
          )}
          {apiResponse?.data?.actions?.delete && (
            <IconButton
              onClick={() => handleClickOpen(params.row.id)}
              sx={{
                backgroundColor: 'var(--action-icon-bg)',
                color: 'var(--action-icon-color)',
                borderRadius: '50%',
                padding: '8px', // Reduce padding size
              }}
              size="small" // Decrease the button size
            >
              <Trash2 size={16} /> {/* Smaller Feather icon size */}
            </IconButton>
          )}
        </>
      ),
    },
  ];

  // const handleDelete = () => {
  //   const toast = Toastmessage('deleted successfully', true)
  //   setOpen(false);
  // };

  const handleDelete = async () => {

    const fetchData = async () => {
      const input_token = deleteEsate + 'DELETE_ESTATE';; // Replace with your actual token
      const apiUrl = 'delete_estate'; // Replace with the actual API endpoint

      const dataInput = {
        login_user_id: userID,
        id: deleteEsate
      };
      try {
        const data = await authApi(input_token, dataInput, apiUrl, token);

        if (data && data.success) {
          await Toastmessage(data.message, true);
          setOpen(false);
          await fetchClients(); // Refresh the list after deletion
        } else if (data && data.message === 'Token has expired') {
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else if (data === undefined) {
          await Toastmessage('No response from server', false);
        } else {
          await Toastmessage(data?.message || 'An error occurred', false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response && error.response.status === 401) {
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else {
          await Toastmessage('Something went wrong', false);
        }
      }
    }
    // Call the function to make the API call
    await fetchData();
  };

  const handleClickOpen = (id) => {
    setOpen(true);
    setDeleteEsate(id)
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchText(value);

    // Search all fields in rows
    const filteredData = rows.filter((row) =>
      Object.values(row).some((field) =>
        String(field).toLowerCase().includes(value)
      )
    );
    setFilteredRows(filteredData); // Update filtered rows
  };

  const clearSearch = () => {
    setSearchText('');
    setFilteredRows(rows); // Reset to original data
  };




  return (

    <Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom='20px'
        backgroundColor='var(--theme-bg-light)'
        padding={2}
        borderRadius={1}
      >
        {/* Left Section */}
        <Box display="flex" alignItems="center">
          <File style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
          <Typography fontSize={12} color="#333333">
            Matters List
          </Typography>
        </Box>

        {/* Right Section */}
        {apiResponse?.data?.actions?.add && (
          <Button
            variant="outlined"
            component={Link}
            to="/addMatters"
            sx={{
              backgroundColor: 'var(--back-button)',
              color: "var(--back-color)",
              fontWeight: 'bold',
              border: 'none',
              padding: '10px 20px'
            }}
            startIcon={<PlusCircle sx={{ fontSize: 17 }} />}
            style={{ textTransform: 'none' }}
          >
            Add New Matters
          </Button>
        )}
      </Box>

 
        <Box display="flex" gap={4} m={3}>
            {menuItems.map((item, index) => (
                <Box
                key={index}
                onClick={() => setActiveMenu(item)}
                sx={{
                    cursor: 'pointer',
                    fontWeight: activeMenu === item ? 'bold' : 'normal',
                    color: activeMenu === item ? '#1a1a1a' : '#555',
                    borderBottom: activeMenu === item ? '2px solid #2962ff' : '2px solid transparent',
                    paddingBottom: '6px',
                    transition: 'border-bottom 0.2s',
                }}
                >
                {item}
                </Box>
            ))}
        </Box>

      <Box className="location-container" m={3}>
        <Box className="location-header ">
          <h2>Total Estate Count {rows.length}</h2>
          <Box sx={{ position: 'relative', width: '300px' }}> {/* Adjust width as needed */}
            <TextField
              label="Search"
              variant="outlined"
              value={searchText}
              onChange={handleSearch}
              className="search-input"
              fullWidth
              InputProps={{
                endAdornment: searchText && (
                  <span
                    onClick={() => clearSearch()}
                    style={{
                      cursor: 'pointer',
                      color: '#aaa',
                      marginRight: '10px',
                    }}
                  >
                    ✕
                  </span>
                ),
              }}
            />
          </Box>
        </Box>
        <div sx={{ m: 0, p: 0 }}>
          <Box sx={{ height: 400, width: '100%', overflow: 'auto' }}>
            <DataGrid
              rows={rows}
              columns={columns}
              pageSize={5}
              autoHeight
              pagination
              disableSelectionOnClick
              rowsPerPageOptions={[]}
              className="data-grid"
              sx={{ width: '100%' }} // Ensure DataGrid takes full width
            />

          </Box>
        </div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirm Deletion?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this Estate?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Disagree</Button>
            <Button onClick={handleDelete} autoFocus>
              Agree
            </Button>
          </DialogActions>
        </Dialog>
      </Box>

    </Box>
  );
}
